var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { useTypedSelector } from "../state/store";
import { scrollToRef } from "../utils";
var Message = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var msgColor = _a.msgColor;
  return "\n  display: flex\n  border-style: solid;\n  border-width: 0.25rem;\n  border-color: " + msgColor + "\n  padding: 1rem 0;\n  text-align: center;\n  margin: 0 auto;\n  width: 50%;\n  p {\n    margin: auto;\n    padding: .4rem 0;\n    color: " + msgColor + ";\n    font-size: .8rem;\n    font-weight: 500;\n    font-family: Poppins;\n    border-left: 3px solid red;\n    background: #ECF6FB;\n\n    }\n  ";
});
var Break = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-basis: 100%;\n  height: 0;\n"], ["\n  flex-basis: 100%;\n  height: 0;\n"])));
var Notification = function Notification(_a) {
  var scrollRef = _a.scrollRef;
  var messageState = useTypedSelector(function (state) {
    return state.message;
  });
  if (messageState.message) {
    var color = messageState.error && "#F76D82" || null;
    scrollToRef(scrollRef);
    return React.createElement(Message, {
      msgColor: color
    }, React.createElement("p", null, messageState.message));
  }
  return null;
};
export default Notification;
var templateObject_1, templateObject_2;